<template>
  <div class="modal fade" :id="id" tabindex="-1" aria-labelledby="assignUsersModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <form @submit.prevent="assignRightAccessToDoor">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="assignUsersModalLabel">
              <i class="fa fa-bell me-2"></i>
              {{ $t('access.assign_users_to_door') }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <Select2
                  containerClass="col-12"
                  name="assign-users"
                  :multiple="true"
                  :label="$t('access.label.users')"
                  labelClass="d-flex align-items-center fs-6 fw-bold mb-2"
                  selectClass="form-select form-select-solid"
                  :isRequired="true"
                  :placeholderText="$t('access.placeholder.users')"
                  v-model="selectedUsers"
                  :IsInputGroup="false"
              >
                <option v-for="user in unassignedUsers" :key="user.id" :value="user.id">
                  {{ user.fullname || user.name }}
                </option>
              </Select2>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close" @click="closeModal"></Button>
            <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits, onMounted, ref } from 'vue'
import Button from "@/components/Button.vue"
import Select2 from "@/components/Select2.vue";
import { useI18n } from 'vue-i18n'
import {useStore} from "vuex";
import {useSwal} from "@/composables/useSwal";

const store = useStore()
const { t } = useI18n()
const {showSwal} = useSwal()

const props = defineProps({
  availableUsers: {
    type: Array,
    default: () => []
  },
  perimeter: {
    type: Object,
    required: true,
    default: () => {}
  },
  userAssignSonote: {
    type: Array,
    default: () => []
  },
  id: {
    type: String,
    required: true,
    default: 'assign_users_modal'
  }
})

const emit = defineEmits(['callback'])


const isLoading = ref(false)
const selectedUsers = ref([])

const userAssignSonote = computed(() => props.userAssignSonote || [])

const userAssignSonoteIds = computed(() => {
  const response = userAssignSonote.value || {}
  const data = response.data || []

  return data
      ?.filter(assignment => assignment.door_id === props.perimeter?.id)
      ?.map(assignment => assignment.user_id) || []
})


const unassignedUsers = computed(() => {
  const all = store.getters['user/getUsers'] || []
  const assignedSonoteIds = userAssignSonoteIds.value
  return all.filter(u => !assignedSonoteIds.includes(u.id))
})

function loadData() {
  store.dispatch('user/loadUsers')
}

function assignRightAccessToDoor() {
  showSwal(
      '',
      i18n.global.t('access.swal.assign_ring')
  ).then(async (result) => {
    if (result.value) {
      isLoading.value = true

      let formData = {
        door_id: props.perimeter.id,
        user_id: selectedUsers.value,
      }

      store.dispatch('perimeters/assignRightAccessToDoor', formData)
          .then(() => {
            closeModal()
            loadUserAssignRightToDoor()
            window.toastr['success'](i18n.global.t('notification.assign_ring'))
            emit('callback')
          })
          .catch(() => {
            isLoading.value = false
          })
    }
  })
}

function closeModal(){
  $('#'+props.id).modal('hide')
  selectedUsers.value = []
}

function loadUserAssignRightToDoor(){
  store.dispatch('perimeters/loadUserAssignDoorSonote')
}

onMounted(() => {
  loadData()
  loadUserAssignRightToDoor()
})
</script>

<style scoped>
</style>
